import { Ellipsis } from '@zoom/components';
import { EllipsisProps } from '@zoom/components/dist/Ellipsis';
import React from 'react';

type EllipsisContentPropsTypes<C extends React.ElementType> = {
  as?: C;
  ellipsisProps?: EllipsisProps;
} & React.DetailedHTMLProps<React.HTMLAttributes<C>, C> &
  React.PropsWithChildren;

type EllipsisContentComponent = <C extends React.ElementType = 'td'>(
  props: EllipsisContentPropsTypes<C>
) => React.ReactElement | null;

export const EllipsisContent: EllipsisContentComponent = ({
  as: Component = 'div',
  ellipsisProps,
  children,
  ...props
}) => (
  <Component {...props}>
    <Ellipsis {...ellipsisProps}>{children}</Ellipsis>
  </Component>
);
